import { createQueryKeyStore } from "@lukemorales/query-key-factory"

export const queries = createQueryKeyStore({
  epl: {
    campaign: ({ userId, campaignId }) => ({
      queryKey: [userId, campaignId],
      contextQueries: {
        rules: {
          queryKey: [],
        },
        history: {
          queryKey: [],
        },
      },
    }),
    termsStatus: ({ userId, eiasToken }) => ({
      queryKey: [userId, eiasToken],
    }),
    availableSites: userId => ({
      queryKey: [userId],
    }),
    markets: ({ userId, eiasToken }) => ({
      queryKey: [userId, eiasToken],
      contextQueries: {
        all: {
          queryKey: [],
        },
      },
    }),
    miniDashboard: ({ userId, eiasToken, currency }) => ({
      queryKey: [userId, eiasToken, currency],
    }),
    onboarding: userId => ({
      queryKey: [userId],
    }),
    report: ({ userId, eiasToken, params }) => ({
      queryKey: [userId, eiasToken, params],
      contextQueries: {
        aggregated: {
          queryKey: [],
        },
        campaign: {
          queryKey: [],
        },
        chart: {
          queryKey: [],
        },
        missing: {
          queryKey: [],
        },
      },
    }),
    optOut: userId => ({
      queryKey: [userId],
    }),
    originSettings: ({ userId, eiasToken }) => ({
      queryKey: [userId, eiasToken],
    }),
    marketSettings: ({ userId, eiasToken }) => ({
      queryKey: [userId, eiasToken],
    }),
    hadPromotedItems: userId => ({
      queryKey: [userId],
    }),
    excludeItems: ({ userId, params = null }) => ({
      queryKey: [userId],
      contextQueries: {
        status: {
          queryKey: [],
        },
        list: {
          queryKey: [params],
        },
      },
    }),
  },
  user: {
    accounts: userId => ({
      queryKey: [userId],
    }),
    entitlements: userId => ({
      queryKey: [userId],
    }),
    plans: userId => ({
      queryKey: [userId],
      contextQueries: {
        available: { queryKey: [] },
        subscribed: { queryKey: [] },
      },
    }),
    checkout: userId => ({
      queryKey: [userId],
    }),
    checkPaymentUpdateStatus: userId => ({
      queryKey: [userId],
    }),
    marketingConsent: userId => ({
      queryKey: [userId],
    }),
    invoiceDetails: userId => ({
      queryKey: [userId],
    }),
  },
  finance: {
    checkoutStatus: processId => ({
      queryKey: [processId],
    }),
    updatePaymentMethodProcess: processId => ({
      queryKey: [processId],
    }),
    invoicesGetList: params => ({
      queryKey: [params],
    }),
    invoiceGetSingle: invoiceId => ({
      queryKey: [invoiceId],
    }),
    historicalInvoicesGetUrl: fileId => ({
      queryKey: [fileId],
    }),
  },
})
